<template>
    <div class="d-flex align-center">
        <div class="num font-size-12 font-size-lg-14 font-weight-bold color-white text-center d-flex align-center justify-center bg-black" data-aos="fade-right"><span>{{num}}</span></div>
        <div :class="'num-content '+space" data-aos="fade-left"><slot/></div>
    </div>
</template>

<script>

export default{
    props : {
        num : {type :String, default : ""},
        space : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.num{
    border-radius: 50%;
    width: 28px;
    height: 28px;
}
.num-content{
    width: calc(100% - 28px);
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .num{
        width: 32px;
        height: 32px;
    }
    .num-content{
        width: calc(100% - 32px);
    }
    .num span{
        position: relative;
        top: -1px;
    }
}
@media (min-width:1200px){
}

</style>